<template>
  <div class="shadow-sm border border-teal-500 rounded p-4 bg-white">
    <p>
      {{ fullName }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      const { firstName, lastName } = this.person;

      return [firstName, lastName].filter(Boolean).join(' ');
    },
  },
};
</script>
